import React, { FunctionComponent } from "react";
import IntroPanel from "./IntroPanel";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../store";
import { DistrictOwnerDashboardTabKeys } from "../../../../pages/district-owner-dashboard/DistrictOwnerDashboard";
import { CoachDashboardTabKeys } from "../../../../pages/coach-dashboard/CoachDashboard";
import useActiveTab from "../../../../pages/parent-dashboard/useActiveTab";

type OwnProps = {
  forParent?: boolean;
  fromRecommendation?: boolean;
};

type Props = OwnProps;

const NoGroupsContainer: FunctionComponent<Props> = (props) => {
  const { changeActiveTab } = useActiveTab();
  const messageParts = useSelector((s: ApplicationState) => s.onboarding.messageParts);

  const handleGotItClick = () => {
    changeActiveTab(CoachDashboardTabKeys.YOUR_DATA_AND_INTERVIEWS || DistrictOwnerDashboardTabKeys.MANAGE_DISTRICT_DATA);
  };

  return (
    <div className="mt-3">
      <IntroPanel onClick={handleGotItClick} fromRecommendation = {props.fromRecommendation} messageParts = {messageParts}/>
    </div>
  );
};

export default NoGroupsContainer;
